import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Card, CardMedia, CardActions, CardActionArea, CardContent, Typography, Button, Box } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    height: '100%',

    '& .MuiPaper-root': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  container: {
    width: 'calc(100% - 280px)',
    marginLeft: '256px',
    minHeight: 'calc(100vh - 64px)',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'auto',
    },
  },
  media: {
    height: '140px',
  },
  
  content: {
    // height: '140px',
    overflow: 'hidden',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
  },
  
  pageTitle: {
    marginBottom: theme.spacing(2),
    color: 'rgba(51, 51, 51, 0.87)',
  },
  
  cardFooter: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    marginTop: 'auto',
    marginBottom: 0,
  },
  
  cardButton: {
    color: '#90C71A',
  },
  
  paginationRoot: {
    '& .Mui-selected': {
      background: '#90C71A',
    },
  },
  
  paginationContainer: {
    marginTop: theme.spacing(4),
  },
}));


function VideoList(props) {
  const classes = useStyles();

  // const {currentPage, pageCount, perPage, totalCount} = props.pagination

  const [page, setPage] = React.useState(1);
  const paginationChange = (event, value) => {
    setPage(value);
    props.paginationChange(value);
  };

  return (
      <Container className={classes.container} maxWidth="md">
        <Typography gutterBottom variant="h5" className={classes.pageTitle} component="h1">Видеоуроки</Typography>
        <Grid container className={classes.root} spacing={3}>
          {props.cardList.length > 0 ? props.cardList.map((item, index) => (
            <Grid item md={4}  sm={6} xs={12} key={item.slug}>
              <Card className={classes.root}>
                <CardActionArea component={RouterLink} to={'/video/' + item.slug}>
                  <CardMedia
                    className={classes.media}
                    image={props.imageList[index] || '/'}
                    // title="Contemplative Reptile"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="h2" style={{color:'#666666'}}>
                      {item.title}
                    </Typography>
                    <Typography className={classes.content} variant="body2" color="textSecondary" component="p">
                      {item.preview_text}
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions className={classes.cardFooter}>
                  <Button size="medium" className={classes.cardButton} component={RouterLink} to={'/video/' + item.slug}>
                    СМОТРЕТЬ
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          )): ''}
        </Grid>
        {props.pagination.pageCount > 1 ? 
          <Box className={classes.paginationContainer}>
            <Pagination 
              className={classes.paginationRoot}
              count={Number(props.pagination.pageCount)}
              page={page}
              color="primary"
              onChange={paginationChange}
            />
          </Box>
        : ''}
      </Container>
  );
}

export default VideoList;
